<template>
    <div class="collapse-panel">
        <div class="collapse-header weui-flex" :class="expand?'border-bottom':''">
            <div class="weui-flex__item collapse-title">{{ title }}</div>
            <div @click="toggle" class="collapse-btn">{{ expand ? '收拢' : '展开' }}<span class="iconfont"
                    :class="expand ? 'icon-shang' : 'icon-xia'"></span></div>
        </div>
        <template v-if="expand">
            <slot />
        </template>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '明细'
        }
    },
    data() {
        return {
            expand: false
        }
    },
    methods: {
        toggle() {
            this.expand = !this.expand
        }
    }
}
</script>

<style scoped>
.collapse-header {
    background-color: var(--weui-BG-2);
    padding: 10px;
}

.collapse-title {
    color: var(--weui-FG-1);
}

.collapse-btn {
    color: var(--weui-LINK);
}
</style>